import {getParamsFromString} from "../../../../Components/JsonScreen/Utils";

/**
 *
 * @param globalValues
 * @param hideCondition
 * @param screenName
 * @returns {boolean}
 */
export function checkHidden(globalValues, hideCondition, screenName) {
    if (hideCondition) {
        const result = getParamsFromString(hideCondition, globalValues, screenName, {}, false, globalValues?._preScript)
        return result !== 'false'
    }
    return false;
}
export function executeBool(globalValues, condition, screenName) {
    if (condition) {
        const result = getParamsFromString(condition, globalValues, screenName, {})
        return result !== 'false'
    }
    return false;
}